import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import { brandDetector } from '@/brands';

let brandStyles = brandDetector();


const info = {
	state: {
		textosInfoPopup: {
			cv_documentacion: {
				es: {
					titulo: 'Autorizo el uso de mi CV',
					texto: 'Si autorizas, tenemos tu permiso para presentar tu CV a ofertas y empresas que consideremos que sean de tu interés, se publiquen o no en el portal. Te avisaremos cada vez que te presentemos a una oferta.'
				},
				en: {
					titulo: "I authorize the use of my CV",
					texto: "If you authorize it, we have your permission to submit your CV to offers and companies that we consider may be of interest to you, whether or not they are published on the portal. We will notify you every time we submit your profile to an offer."
				}
			},
			uso_logo: {
				es: {
					titulo: 'Autorizo el uso de la imagen de la empresa',
					texto: 'Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en los portales de estudiantes y antiguos alumnos/as. Aunque autorices, cuando crees ofertas podrás configurar si quieres que se muestren los datos de tu empresa o no.'
				},
				en: {
					titulo: "I authorize the use of the company's image",
					texto: "If you authorize it, you give us permission to display the company's logo on the student and alumni portals. Even if you authorize it, when you create job postings you will be able to choose whether or not you want your company information to be visible."
				}
			},
			mostrar_empresa: {
				es: {
					titulo: 'Quiero ocultar los datos de mi empresa para esta oferta',
					texto: 'Por defecto, mostraremos los datos básicos de tu empresa en cada oferta que publiques. Si quieres publicar anónimamente, marca esta opción, no se mostrarán logo, nombre, contacto... de tu empresa.'
				},
				en: {
					titulo: "I want to hide my company data for this offer",
					texto: "By default, we'll show your basic business details on every offer you publish. If you want to publish anonymously, check this option, logo, name, contact... of your company."
				}
			},
			url_portfolio: {
				es: {
					titulo: 'URL del documento',
					texto: 'Si no puedes añadir tu documento porque supera 2Mb, añade aquí la url donde está alojado.'
				},
				en: {
					titulo: "Document URL",
					texto: "If you cannot upload your document because it exceeds 2MB, add here the URL where it is hosted."
				}
			},
			info_oferta_pendiente: {
				es: {
					titulo: '¡Atención!',
					texto: 'Solamente puedes modificar los detalles de tus ofertas mientras estén “pendiente” de validar y no caducadas. Si quieres modificar cualquier detalle una oferta que no está pendiente, por favor contacta con nosotros.'
				},
				en: {
					titulo: "Attention!",
					texto: "You can only edit the details of your offers while they are pending validation and not expired. If you need to edit any detail of an offer that is not pending, please contact us."
				}
			},
			comunicaciones_email_personal: {
				es: {
					titulo: 'Avisos en el email personal',
					texto: 'Marca esta casilla si quieres recibir las comunicaciones relacionadas con prácticas o empleo en tu email personal, en vez de en tu email de estudiante.'
				},
				en: {
					titulo: "Notifications to personal email",
					texto: "Tick this box if you want to receive internship or employment communications in your personal email instead of your student email."
				}
			},
			editar_personales: {
				es: {
					titulo: 'Edición de datos personales',
					texto: 'Si alguno de los datos no editables no es correcto, por favor, contacta con nosotros para indicarte dónde acudir para modificarlo.'
				},
				en: {
					titulo: "Personal data editing",
					texto: "If any non-editable data is not correct, please contact us and we will tell you where to go to modify it."
				}
			},
			busquedaactivapracticas: {
				es: {
					titulo: 'Búsqueda activa',
					texto: 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de prácticas. Además, consientes en que se envíe tu candidatura desde los servicios de prácticas y empleo de la universidad, sin inscripción previa por tu parte.'
				},
				en: {
					titulo: "Active search",
					texto: "Only when you have active search enabled (green checkbox) will you be able to apply for internship offers. In addition, you consent to your application being sent by the university's internships and employment services without prior application by you."
				}
			},
			busquedaactivaempleo: {
				es: {
					titulo: 'Búsqueda activa',
					texto: 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de empleo. Además, consientes en que se envíe tu candidatura desde los servicios de prácticas y empleo de la universidad, sin inscripción previa por tu parte.'
				},
				en: {
					titulo: "Active search",
					texto: "Only when you have active search enabled (green checkbox) will you be able to apply for job offers. In addition, you consent to your application being sent by the university's internships and employment services without prior application by you."
				}
			},
			busquedaactivaempleo_uib: {
				es: {
					titulo: 'Búsqueda activa',
					texto: 'Solamente cuando tengas la búsqueda activada (casilla en verde) podrás inscribirte en ofertas de empleo.'
				},
				en: {
					titulo: "Active search",
					texto: "Only when you have active search enabled (green checkbox) will you be able to apply for job offers."
				}
			},
			documentacion: {
				es: {
					titulo: 'Documentación',
					texto: '¡Atención! Asegúrate de tener la información actualizada, las empresas a las que se mande tu currículum podrán acceder a esta documentación. Al subir cualquier archivo, consientes a que todas las empresas que tienen tu currículum accedan a esta información.'
				},
				en: {
					titulo: "Documentation",
					texto: "Attention! Make sure your information is up to date; companies to which your CV is sent can access this documentation. By uploading any file, you consent to all companies that have your CV accessing this information."
				}
			},
			limitaciones_fichero: {
				es: {
					titulo: 'Ficheros permitidos',
					texto: '¡Atención! Los ficheros no pueden superar los 2Mb. Las extensiones permitidas son las siguientes: docx, doc, pdf, odt, odp, txt, pptx, pps, ppsx, ppt, csv, xlsx, png, jpg, jpeg, bmp, gif, tiff y tif.'
				},
				en: {
					titulo: "Allowed files",
					texto: "Attention! Files cannot exceed 2MB. Allowed extensions are: docx, doc, pdf, odt, odp, txt, pptx, pps, ppsx, ppt, csv, xlsx, png, jpg, jpeg, bmp, gif, tiff and tif."
				}
			},
			fichero_pdf: {
				es: {
					titulo: 'Ficheros permitidos',
					texto: '¡Atención! Los ficheros no pueden superar los 2Mb. Sólo se permiten ficheros PDF.'
				},
				en: {
					titulo: "Allowed files",
					texto: "Attention! Files cannot exceed 2MB. Only PDF files are allowed."
				}
			},
			documentos_empresa: {
				es: {
					titulo: 'Documentación de tu empresa',
					texto: 'Si se te ha requerido o deseas aportar documentación adicional podrás adjuntarla aquí. ¡Atención! Asegúrate de tener la información actualizada, si alguno de los documentos ya subidos no está actualizado, elimínalo y dalo de alta de nuevo.'
				},
				en: {
					titulo: "Your company documentation",
					texto: "If requested, or if you want to provide additional documentation, you can attach it here. Attention! Make sure information is up to date. If any uploaded document is outdated, delete it and upload it again."
				}
			},
			documentos_privados: {
				es: {
					titulo: "Documentación privada",
					texto: "Si deseas, o se te ha requerido aportar documentación adicional desde tu universidad podrás adjuntarla aquí. Las empresas no tendrán acceso a esta información. ¡Atención! Asegúrate de tener la información actualizada, si alguno de los documentos ya subidos no está actualizado, dalo de alta de nuevo."
				},
				en: {
					titulo: "Private documentation",
					texto: "If you want, or if your university has asked you to provide additional documentation, you can attach it here. Companies will not have access to this information. Attention! Make sure information is up to date; if any uploaded document is outdated, upload it again."
				}
			},
			documentacion_ligada_procesos: {
				es: {
					titulo: "Documentación ligada a procesos",
					texto: "Si en algún proceso del que formas parte, la empresa ha solicitado documentación específica, podrás darla de alta aquí."
				},
				en: {
					titulo: "Process-related documentation",
					texto: "If in any process you are part of, the company has requested specific documentation, you can upload it here."
				}
			},
			registro_alumnos: {
				es: {
					titulo: "",
					texto: "Indica la titulación que consideres más relevante, podrás completar tu perfil con otras titulaciones una vez registrado/a."
				},
				en: {
					titulo: "",
					texto: "Indicate the degree you consider most relevant. You can complete your profile with other degrees once you are registered."
				}
			},
			ocultar_empresa: {
				es: {
					titulo: "Me gustaría que el nombre de mi empresa fuera visible.",
					texto: "Por defecto, no mostraremos los datos básicos de tu empresa en cada oferta que publiques. Si quieres publicarlo, marca esta opción y se mostrarán logo, nombre, contacto... de tu empresa."
				},
				en: {
					titulo: "I would like my company name to be visible.",
					texto: "By default, we do not show your company basic data in each offer you publish. If you want to show it, select this option and logo, name and contact details will be displayed."
				}
			},
			envio_postal: {
				es: {
					titulo: "Domicilio para el envio postal de facturas",
					texto: "Por favor indique la dirección completa con código postal y localidad a la que podemos enviar las facturas en formato papel (no digital) que, en su caso, sean necesarias."
				},
				en: {
					titulo: "Postal address for sending invoices",
					texto: "Please indicate the full address, including postal code and city, to which we can send invoices in paper format (not digital), when needed."
				}
			},
			descargarcv: {
				es: {
					titulo: "Ver CV",
					texto: "Pinchando en este botón te descargas un PDF con tu currículum autogenerado con los datos de tu perfil.<br><br>Este PDF es el que recibe la empresa cuando se envía tu candidatura a cualquier oferta, así que te recomendamos tenerlo lo más actualizado y completo posible.<br><br>Si lo deseas también puedes adjuntar tu propia versión de CV desde el epígrafe “Documentación adjunta”, aunque la empresa siempre recibirá también el autogenerado."
				},
				en: {
					titulo: "View CV",
					texto: "By clicking this button, you download a PDF with your auto-generated CV based on your profile data.<br><br>This is the PDF companies receive when your application is sent to any offer, so we recommend keeping it as up to date and complete as possible.<br><br>If you wish, you can also attach your own CV version from the “Attached documentation” section, although the company will always receive the auto-generated one as well."
				}
			},
			discapacidad_uc3m: {
				es: {
					titulo: "",
					texto: "El dato de discapacidad no será visible ni en tu CV ni en el perfil que consulten las empresas de tus futuras candidaturas. Será únicamente tratado desde la Oficina de Prácticas y Empleo de UC3M.<br>Recuerda que existen programas específicos de prácticas y empleo para usuarios con discapacidad certificada."
				},
				en: {
					titulo: "",
					texto: "Disability information will not be visible in your CV or in the profile viewed by companies in your future applications. It will only be processed by the UC3M Internship and Employment Office.<br>Remember there are specific internship and employment programs for users with certified disabilities."
				}
			},
			candidato_preferido: {
				es: {
					titulo: "",
					texto: "Para cualquier consulta relacionada con la manera de cumplimentar este campo, por favor contacte con nosotros."
				},
				en: {
					titulo: "",
					texto: "For any query related to how to fill in this field, please contact us."
				}
			},
			tratamiento_datos: {
				es: {
					titulo: "",
					texto: "El texto indicado se incluirá en la cláusula 15 del Convenio y hace referencia al tratamiento de los Datos personales de los firmantes del presente acuerdo.<br>Puede consultar el texto completo de información sobre tratamiento de datos por la Universidad y la Fundación en <a href='https://www.uc3m.es/orientacionyempleo/gestion-practicas' target='_blank'>https://www.uc3m.es/orientacionyempleo/gestion-practicas</a>"
				},
				en: {
					titulo: "",
					texto: "The indicated text will be included in clause 15 of the Agreement and refers to the processing of personal data of the signatories of this agreement.<br>You can consult the full data processing information by the University and the Foundation at <a href='https://www.uc3m.es/orientacionyempleo/gestion-practicas' target='_blank'>https://www.uc3m.es/orientacionyempleo/gestion-practicas</a>."
				}
			},
			datos_realizacion: {
				es: {
					titulo: "",
					texto: "Completa este campo en función de los conocimientos específicos que pondrá en práctica el estudiante seleccionado, la formación que adquirirá, así como el seguimiento que vaya a realizarse de la realización de las prácticas, por ejemplo: reunión presencial semanalmente."
				},
				en: {
					titulo: "",
					texto: "Complete this field according to the specific knowledge the selected student will apply, the training they will acquire, and the follow-up planned for the internship, for example: a weekly in-person meeting."
				}
			},
			"convenio Generado": {
				es: {
					titulo: "Convenio generado",
					texto: "El convenio ha sido generado y está pendiente de firmar por parte de tu empresa."
				},
				en: {
					titulo: "Generated agreement",
					texto: "The agreement has been generated and is awaiting signature by your company."
				}
			},
			"convenio Formalizado": {
				es: {
					titulo: "Convenio formalizado",
					texto: "El convenio ya está formalizado."
				},
				en: {
					titulo: "Formalized agreement",
					texto: "The agreement is already formalized."
				}
			},
			"convenio Firmado empresa": {
				es: {
					titulo: "Convenio Firmado empresa",
					texto: "El convenio ya ha sido firmado por parte de tu empresa y está pendiente de revisión y firma por parte de la Universidad"
				},
				en: {
					titulo: "Agreement signed by the company",
					texto: "The agreement has been signed by your company and is awaiting review and signature by the University."
				}
			},
			"convenio Erróneo empresa": {
				es: {
					titulo: "Convenio Erróneo empresa",
					texto: "El convenio contiene algún error y debe ser revisado."
				},
				en: {
					titulo: "Agreement with errors",
					texto: "The agreement contains an error and must be reviewed."
				}
			},
			"convenio Caducado": {
				es: {
					titulo: "Convenio Caducado",
					texto: "El convenio ha caducado"
				},
				en: {
					titulo: "Expired agreement",
					texto: "The agreement has expired."
				}
			},
			"convenio Enviado Secretaría": {
				es: {
					titulo: "Convenio Enviado secretaría",
					texto: "El convenio esta enviado y pendiente de revisión por secretaría"
				},
				en: {
					titulo: "Agreement sent to the Secretariat",
					texto: "The agreement has been sent and is awaiting review by the Secretariat."
				}
			},
			"convenio Generated": {
				en: {
					titulo: "Generated agreement",
					texto: "The agreement has been generated and is awaiting signature by your company."
				}
			},
			"convenio Formalized": {
				en: {
					titulo: "Formalized agreement",
					texto: "The agreement is already formalized."
				}
			},
			"convenio Signed by the company": {
				en: {
					titulo: "Agreement signed by the company",
					texto: "The agreement has been signed by your company and is awaiting review and signature by the University."
				}
			},
			"convenio Agreement with errors": {
				en: {
					titulo: "Agreement with errors",
					texto: "The agreement contains an error and must be reviewed."
				}
			},
			"convenio Expired": {
				en: {
					titulo: "Expired agreement",
					texto: "The agreement has expired."
				}
			},
			"convenio Sent to the Secretariat": {
				en: {
					titulo: "Agreement sent to the Secretariat",
					texto: "The agreement has been sent and is awaiting review by the Secretariat."
				}
			},
			"notamedia": {
				es: {
					titulo: "Nota media",
					texto: 'Nota media de 1 a 4. Consulta las <a target="_blank" href="https://sede.csic.gob.es/tabla_conversion">equivalencias</a>.'
				},
				en: {
					titulo: "Average grade",
					texto: "Average grade from 1 to 4. Check the <a target='_blank' href='https://sede.csic.gob.es/tabla_conversion'>equivalences</a>."
				}
			},
			"ultimoconvenio": {
				es: {
					titulo: "Rellenar datos",
					texto: 'Descarga los datos del último convenio y utilízalos para generar uno nuevo.'
				},
				en: {
					titulo: "Fill in data",
					texto: "Download the data from the last agreement and use it to generate a new one."
				}
			},
			"ocultartitulacion": {
				es: {
					titulo: "Atención",
					texto: "Si marcas la casilla para ocultar esta titulación de tu perfil, ni las empresas que reciban tu candidatura ni el CV que se autogenera desde tu perfil incluirá esta titulación."
				},
				en: {
					titulo: "Attention",
					texto: "If you check the box to hide this degree from your profile, neither companies that receive your application nor the auto-generated CV from your profile will include this degree."
				}
			},
			"ayudaEstudioUIB": {
				es: {
					titulo: "Atención",
					texto: "Para consultar las condiciones haz clic en el siguiente <a target='_blank' href='/uib/condiciones-practicas#economicas'>enlace</a>"
				},
				en: {
					titulo: "Attention",
					texto: "To check the conditions, click the following <a target='_blank' href='/uib/condiciones-practicas#economicas'>link</a>."
				}
			},
			"horasDiaUIB": {
				es: {
					titulo: "Atención",
					texto: "El número máximo de horas de prácticas diarias es de 5, con un máximo de 25 horas semanales. Con esta finalidad se pretende que el estudiante pueda compaginar los estudios con las prácticas remuneradas. Los días que los estudiantes tengan que hacer exámenes en la UIB no tendrán que realizar prácticas. La empresa/entidad se compromete a dar facilidades para establecer el horario de los estudiantes. No obstante, durante los periodos no lectivos, el horario mencionado se puede aumentar hasta un máximo de 7 horas diarias, en este caso también habrá un aumento de la ayuda económica correspondiente."
				},
				en: {
					titulo: "Attention",
					texto: "The maximum number of internship hours per day is 5, with a maximum of 25 hours per week. This is intended to allow the student to combine studies with paid internships. On days when students have exams at UIB, they will not have to do internships. The company/entity commits to providing flexibility to set student schedules. However, during non-teaching periods, this schedule may be increased up to a maximum of 7 hours per day, with the corresponding increase in financial support."
				}
			},
			"infoSeguridadSocial": {
				es: {
					titulo: "¿Cómo obtener mi número de la SS? ",
					texto: "En la Administración de la Tesorería General de la Seguridad Social en la que radique el domicilio del ciudadano o donde esté domiciliada la empresa en que presta servicios el trabajador. Si dispone de un certificado digital puede acceder al <a target='_blank' href='https://sede.seg-social.gob.es/wps/portal/sede/sede/Ciudadanos/afiliacion+e+inscripcion/202088?changeLanguage=es'>servicio Asignación de número de la Seguridad Social en la Sede Electrónica</a>."
				},
				en: {
					titulo: "How can I get my Social Security number?",
					texto: "At the office of the General Treasury of Social Security corresponding to the citizen's address or where the company where the worker provides services is registered. If you have a digital certificate, you can access the <a target='_blank' href='https://sede.seg-social.gob.es/wps/portal/sede/sede/Ciudadanos/afiliacion+e+inscripcion/202088?changeLanguage=en'>Social Security Number Assignment service in the Electronic Office</a>."
				}
			},
			"infoCosteSS": {
				es: {
					titulo: " ¿Su entidad acepta asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social de los alumnos que realicen prácticas formativas o prácticas académicas externas en su institución tal y como recoge en el Real Decreto-ley 2/2023?",
					texto: "<li>Si, aceptamos asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.</li><br><li>No Aceptamos. Solicitamos que sea la Universidad Pontificia Comillas, la entidad que asuma el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del alumno, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.</li>"
				},
				en: {
					titulo: "Does your entity agree to assume compliance, management, and cost of Social Security obligations for students undertaking internships as established in Royal Decree-Law 2/2023?",
					texto: "<li>Yes, we agree to assume compliance, management, and cost of the student's Social Security obligations when this becomes effectively applicable, as established in Royal Decree-Law 2/2023.</li><br><li>No, we do not accept. We request that Universidad Pontificia Comillas assumes compliance, management, and cost of the student's Social Security obligations when this becomes effectively applicable, as established in Royal Decree-Law 2/2023.</li>"
				}
			},
			"tipoFirma": {
				es: {
					titulo: "Elija tipo de firma para el convenio",
					texto: "Firma manual: El Convenio se imprimirá y se firmarán de forma manuscrita dos originales.<br><br>Firma digital: solo si El firmante en la empresa cuenta con certificado electrónico cualificado. Consultar certificados digitales válidos <a  href='https://sedeaplicaciones.minetur.gob.es/Prestadores/' target='_blank'>aquí</a>"
				},
				en: {
					titulo: "Choose signature type for the agreement",
					texto: "Manual signature: The Agreement will be printed and two original copies will be signed by hand.<br><br>Digital signature: only if the company signatory has a qualified electronic certificate. Check valid digital certificates <a href='https://sedeaplicaciones.minetur.gob.es/Prestadores/' target='_blank'>here</a>."
				}
			}
		},
		owntexts: brandStyles.ownpopup_info
	},
	getters: {
		getInfoPopup: state => {
			return (value) => {
				let textos;

				if (state.owntexts) {
					textos = (!!state.owntexts[value]) ? state.owntexts[value] : state.textosInfoPopup[value];
				} else {
					textos = state.textosInfoPopup[value];
				}

				return textos;
			}
		},
	},
	actions: {

	},
	mutations: {

	}
}

export default info;



// WEBPACK FOOTER //
// ./src/store/popup-info.js